<template>
  <section>
    <part-form :pageTitle="$metaInfo.title" />
    <tabs v-if="requirementId" />
  </section>
</template>

<script>
import PartForm from './components/PartForm';
import Tabs from './components/Tabs';

export default {
  props: {
    crfqId: {
      type: [Number, String],
      default: 0,
    }
  },
  components: {
    PartForm,
    Tabs,
  },
  computed: {
    requirementLineId() {
      return this.$route.query.crfqLineId;
    },
    requirementId() {
      return this.$route.query.crfqId;
    },
    partId() {
      return this.$route.query.partId;
    }
  },
  metaInfo() {
    let pageTitle = '';

    if (this.requirementId && this.requirementLineId) {
      pageTitle = `Requirement #${this.requirementLineId}`;
    } else if (this.requirementId) {
      pageTitle = 'Add New Requirement';
    } else {
      pageTitle = 'Create Requirement';
    }

    return { title: pageTitle };
  },
};
</script>
